export default "__VITE_ASSET__DLuIul53__"